export const REDIRECT_PAGE_TYPES = {
  CALENDAR_WITH_DATE: 'calendar-with-date',
  EDIT_EVENT_PAGE: 'edit-event-page',
  OBSERVATION_REPORT: 'observation-report',
  VIEW_OBSERVATION_REPORT: 'view-observation-report'
};
